export const sortDate = (a: string|number, b: string|number) => {
    const aDate = new Date(a);
    const bDate = new Date(b);

    return Number(aDate) - Number(bDate);
};

export const sortNumber = (a: number, b: number) => {
    return a - b;
};

export const sortString = (a: string, b: string) => {
    const aString = a.toString().toUpperCase(); 
    const bString = b.toString().toUpperCase();

    if (aString > bString) {
        return 1;
    }

    if (aString < bString) {
        return -1;
    }

    return 0;
};


// WEBPACK FOOTER //
// ./src/utils/sort.ts